/* Het pad van een beeld zoals het in de content staat (ADR 0024): `/media/` met het pad uit de
 * bibliotheek erachter. De site toont alleen beelden uit de eigen media (ownMedia in lib/media.ts van
 * de site-repo): elk ander adres telt daar als "geen beeld". Dit bestand heeft geen imports, zodat
 * elk onderdeel van de datalaag het kan gebruiken. */

/** Waarmee een beeld in de content begint. */
export const VOORVOEGSEL = '/media/';

/** Wat er mis is met het pad van een beeld, of null. Een leeg pad wordt hier niet nagekeken: of een
 *  beeld mag ontbreken, bepaalt de aanroeper. */
export function keurBeeldpad(pad: string): string | null {
  const p = pad.trim();
  if (p === '') return null;
  if (!p.startsWith(VOORVOEGSEL)) return 'Een afbeelding komt uit de eigen media en begint met /media/.';
  if (p.length === VOORVOEGSEL.length) return 'Na /media/ hoort de naam van het bestand.';
  return null;
}

/** Is dit een pad uit de eigen media waar de site een beeld van maakt? */
export const isBeeldpad = (pad: unknown): pad is string => typeof pad === 'string' && pad.trim() !== '' && keurBeeldpad(pad) === null;
